<template>
  <tabs :agentid="agent.id" class="ut-container-lg">
      <tab name="Active" :selected="true">
        <loading-spinner v-if="activeLams.length === 0 && !leadsFetched" />
          <div class="no-data" v-if="activeLams.length === 0 && leadsFetched">
            You currently have no active leads.
          </div>
          <div class="table-head shadow-box md:ut-flex ut-mb-2 ut-h-12 ut-hidden"
            v-if="activeLams.length !== 0 && leadsFetched">
              <div class="col ut-w-3/5 ut-pl-6">NAME</div>
              <div class="ut-w-3/5 ut-pl-6">ADDRESS</div>
              <div class="ut-w-2/5 ut-pl-6">DATE SENT</div>
              <div class="ut-w-2/5 ut-pl-6">STAGE</div>
              <div class="ut-w-3/5 ut-pl-6">LAST UPDATED</div>
          </div>
          <lead-card v-for="lam in activeLams"
                      :last-update-day="10"
                      :isActive="true"
                      :key="lam.id"
                      :lead="lam"></lead-card>
      </tab>
      <tab name="On hold">
          <div class="no-data" v-if="onHoldLams.length === 0 && leadsFetched">
            You currently have no on hold leads.
          </div>
          <div class="table-head shadow-box md:ut-flex ut-mb-2 ut-h-12 ut-hidden"
            v-if="onHoldLams.length !== 0 && leadsFetched">
              <div class="col ut-w-3/5 ut-pl-6">NAME</div>
              <div class="ut-w-3/5 ut-pl-6">ADDRESS</div>
              <div class="ut-w-2/5 ut-pl-6">DATE SENT</div>
              <div class="ut-w-2/5 ut-pl-6">STAGE</div>
              <div class="ut-w-4/5 ut-pl-6">STATUS</div>
          </div>
          <lead-card v-for="lam in onHoldLams"
                      :last-update-day="10"
                      :onHold="true"
                      :key="lam.id"
                      :lead="lam"></lead-card>
      </tab>
      <tab name="Listed">
          <div class="no-data" v-if="listedLams.length === 0 && leadsFetched">
            You currently have no listed lead.
          </div>
          <div class="table-head shadow-box md:ut-flex ut-mb-2 ut-h-12 ut-hidden"
            v-if="listedLams.length !== 0 && leadsFetched">
              <div class="col ut-w-3/5 ut-pl-6">NAME</div>
              <div class="ut-w-3/5 ut-pl-6">ADDRESS</div>
              <div class="ut-w-2/5 ut-pl-6">DATE SENT</div>
              <div class="ut-w-2/5 ut-pl-6">PRICE</div>
              <div class="ut-w-3/5 ut-pl-6">STATUS</div>
          </div>
          <lead-card v-for="lam in listedLams"
                      :last-update-day="10"
                      :isListed="true"
                      :key="lam.id"
                      :lead="lam"></lead-card>
      </tab>
      <tab name="Closed">
          <div class="no-data" v-if="closedLams.length === 0 && leadsFetched">
            You currently have no closed lead.
          </div>
          <div class="table-head shadow-box md:ut-flex ut-mb-2 ut-h-12 ut-hidden"
            v-if="closedLams.length !== 0 && leadsFetched">
              <div class="col ut-w-3/5 ut-pl-6">NAME</div>
              <div class="ut-w-3/5 ut-pl-6">ADDRESS</div>
              <div class="ut-w-2/5 ut-pl-6">DATE SENT</div>
              <div class="ut-w-3/5 ut-pl-6">STATUS</div>
          </div>
          <lead-card v-for="lam in closedLams"
                      :last-update-day="10"
                      :isClosed="true"
                      :key="lam.id"
                      :lead="lam"></lead-card>
      </tab>
  </tabs>
</template>

<script>

import { mapState } from 'vuex';
import Tab from '@oa-vue/tab/Tab.vue';
import Tabs from '@oa-vue/tabs/Tabs.vue';
import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import { LeadStateType } from '@/Mapper/LeadStateType';
import LeadCard from '@/components/LeadCard.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';

export default {
  name: 'NonePremierLeadsList',
  components: {
    LeadCard,
    Tabs,
    Tab,
    LoadingSpinner,
  },
  props: {
    ak: String,
    leadsFetched: Boolean,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      lams: state => state.leadsListStore.leadsList,
    }),
    activeLams() {
      return this.lams.filter(lam => lam.statetypeid === LeadAgentLeadStateType.Active
        && lam.leadinfo.leadstateid === LeadStateType.Open
        && lam.stagetypeid !== LeadAgentLeadStageType.Listed)
        .sort((a, b) => new Date(b.agentsentleaddate) - new Date(a.agentsentleaddate));
    },
    onHoldLams() {
      return this.lams.filter(lam => lam.leadinfo.leadstateid === LeadStateType.Open
        && lam.statetypeid === LeadAgentLeadStateType.On_Hold)
        .sort((a, b) => new Date(b.lamoffholddatetime) - new Date(a.lamoffholddatetime));
    },
    listedLams() {
      return this.lams.filter(lam => lam.statetypeid === LeadAgentLeadStateType.Active
        && lam.leadinfo.leadstateid === LeadStateType.Open
        && lam.stagetypeid === LeadAgentLeadStageType.Listed)
        .sort((a, b) => new Date(b.agentsentleaddate) - new Date(a.agentsentleaddate));
    },
    closedLams() {
      return this.lams.filter(lam => lam.statetypeid === LeadAgentLeadStateType.Lost
        || lam.statetypeid === LeadAgentLeadStateType.Closed
        || lam.leadinfo.leadstateid === LeadStateType.Lost)
        .sort((a, b) => new Date(b.agentsentleaddate) - new Date(a.agentsentleaddate));
    },
  },
};

</script>

<style scoped lang="scss">
    .table-head{
        border: 1px solid #E3E5E8;
        div{
            @apply ut-text-xs ut-tracking-wide opacity-75;
            opacity: 0.69;
        }
    }

    .shadow-box{
        @apply ut-rounded ut-bg-neutral-001 ;
    }
</style>
